export const ATTACHED_REQUESTS_MODE_FILTER_MODAL_RECIPIENT_GROUP_FIELD_NAME =
  'recipientGroup'

export const ATTACHED_REQUESTS_MODE_FILTER_MODAL_EXCLUDE_ARCHIVED_FIELD_NAME =
  'excludeArchived'

export const ATTACHED_REQUESTS_RECIPIENT_TYPE_OWNERS = 'request_owner'

export const ATTACHED_REQUESTS_RECIPIENT_TYPE_PROVIDERS = 'request_contractor'

const ATTACHED_REQUESTS_MODE_FILTER_MODAL_RECIPIENT_GROUP_PROVIDERS_OPTION = {
  label: 'RequestProfile.AttachedRequestsRecipientGroupProvidersKey',
  value: ATTACHED_REQUESTS_RECIPIENT_TYPE_PROVIDERS,
}

export const ATTACHED_REQUESTS_MODE_FILTER_MODAL_RECIPIENT_GROUP_OWNERS_OPTION =
  {
    label: 'RequestProfile.AttachedRequestsRecipientGroupOwnersKey',
    value: ATTACHED_REQUESTS_RECIPIENT_TYPE_OWNERS,
  }

export const ATTACHED_REQUESTS_MODE_FILTER_MODAL_RECIPIENT_GROUP_OPTIONS = [
  ATTACHED_REQUESTS_MODE_FILTER_MODAL_RECIPIENT_GROUP_OWNERS_OPTION,
  ATTACHED_REQUESTS_MODE_FILTER_MODAL_RECIPIENT_GROUP_PROVIDERS_OPTION,
]
